import createVueComponent from '../createVueComponent';

const MousePointer2 = createVueComponent('MousePointer2Icon', [
  ['path', { d: 'M4 4l7.07 17 2.51-7.39L21 11.07z' }],
]);

export default MousePointer2;
